<template>
  <b-card
    no-body
    class="p-2"
  >
    <h3 class="mb-2">
      {{
        schemeTypePayment.esquemaPagoTipoId == 0
          ? $t("Routes.SchemeTypePaymentAdd")
          : $t("Routes.SchemeTypePaymentEdit")
      }}
    </h3>
    <validation-observer
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <b-form
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <b-row>
          <!-- name work area field -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              :name="$t('humanResources.schemeTypePayment.columns.name')"
              rules="required"
            >
              <b-form-group
                :label="$t('humanResources.schemeTypePayment.columns.name')"
                :state="errors.length > 0 ? false : null"
              >
                <b-form-input v-model="schemeTypePayment.nombre" />
                <b-form-invalid-feedback
                  :state="errors.length > 0 ? false : null"
                >
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- Description Field -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="Description"
              rules="required"
            >
              <b-form-group
                :label="
                  $t('humanResources.schemeTypePayment.columns.description')
                "
                :state="errors.length > 0 ? false : null"
              >
                <b-form-textarea v-model="schemeTypePayment.descripcion" />
                <b-form-invalid-feedback
                  :state="errors.length > 0 ? false : null"
                >
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row class="float-right mt-2 mb-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
          >
            <b-spinner v-if="addingSchemeTypePayment" small class="mr-1" />
            {{
              schemeTypePayment.esquemaPagoTipoId == 0
                ? $t("Lists.Add")
                : $t("Lists.Edit")
            }}
          </b-button>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BFormTextarea,
  BSpinner,

  BFormInvalidFeedback,
  BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import humanResources from '@/services/humanresources.service'
import { ref } from '@vue/composition-api'
import router from '@/router'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormInvalidFeedback,
    BFormGroup,
    BFormTextarea,
    BButton,
    BSpinner,

    ValidationProvider,
    ValidationObserver,
  },
  props: {
    modalCall: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  setup(props, { emit }) {
    const addingSchemeTypePayment = ref(false)
    const schemeTypePayment = ref({
      esquemaPagoTipoId: 0,
      nombre: '',
      descripcion: '',
      archivado: false,
    })

    const blankSchemeTypePayment = {
      esquemaPagoTipoId: 0,
      nombre: '',
      descripcion: '',
      archivado: false,
    }

    const {
      fetchSchemeTypePayment,
      createSchemeTypePayment,
      updateSchemeTypePayment,
    } = humanResources()

    const resetSchemeTypePayment = () => {
      schemeTypePayment.value = JSON.parse(JSON.stringify(blankSchemeTypePayment))
    }

    if (router.currentRoute.params.esquemaPagoTipoId) {
      fetchSchemeTypePayment(router.currentRoute.params.esquemaPagoTipoId, data => {
        schemeTypePayment.value = data
      })
    } else {
      schemeTypePayment.value = JSON.parse(JSON.stringify(blankSchemeTypePayment))
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetSchemeTypePayment)

    const onSubmit = () => {
      addingSchemeTypePayment.value = true
      if (schemeTypePayment.value.esquemaPagoTipoId === 0) {
        createSchemeTypePayment(schemeTypePayment.value, () => {
          addingSchemeTypePayment.value = false
          if (props.modalCall) {
            emit('find-records')
          } else {
            router.push({ name: 'apps-human-resources-scheme-type-payment-list' })
          }
        })
      } else {
        updateSchemeTypePayment(schemeTypePayment.value.esquemaPagoTipoId, schemeTypePayment.value, () => {
          addingSchemeTypePayment.value = false
          router.push({ name: 'apps-human-resources-scheme-type-payment-list' })
        })
      }
    }

    return {
      schemeTypePayment,
      addingSchemeTypePayment,
      required,
      getValidationState,
      refFormObserver,
      resetForm,
      onSubmit,

    }
  },
}
</script>
